/**
 * Контейнер выпадающего списка для селекта внутри модалки — родитель самого поля.
 *
 * В embed таблица стилей платформы придавливает `.ant-select-dropdown` правилом
 * `z-index: 7 !important` (см. `stickyToolbar.ts`). Список, отрисованный в `body`,
 * поэтому уходит ПОД модалку (её слой — 1000+): «Аккаунты» в «Поиске парента» и
 * сортировка в «Конкурентах» не открывались (QA 14.10, WS 15587410). Внутри модалки
 * те же 7 считаются уже в её слое — и список ложится поверх её содержимого.
 */
export function popupInside(trigger: HTMLElement): HTMLElement {
  return trigger.parentElement ?? document.body;
}
